import { Component } from 'react';
import { setDefaultNode as setDefaultNodeDeprecated } from 'UIComponents/utils/RootNode';
import { setDefaultNode } from 'foundations-components/transitional/utils/RootNode';
// @ts-expect-error Not migrated yet
import SharedDragDropContext from 'InpageEditorUI/lib/DragDropContext';
import { InpageModes } from 'ContentEditorUI/lib/app/constants';
// @ts-expect-error Not migrated yet
import ClickCatcher from 'InpageEditorUI/components/ClickCatcher';
// @ts-expect-error Not migrated yet
import { isPreviewOnly } from 'InpageEditorUI/lib/urlUtils';
import { NAMESPACE_CLASS } from 'ContentEditorUI/lib/inpage/Constants';
// @ts-expect-error Not migrated yet
import XRayPageCrawlerContainer from './xray/XRayPageCrawlerContainer';
import { Z_INDEX_MAX_LAYERS } from '../lib/layoutSection/constants';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class InpageRoot extends Component {
  componentDidMount() {
    if (this.uiComponentRoot) {
      setDefaultNodeDeprecated(this.uiComponentRoot);
      setDefaultNode(this.uiComponentRoot);
    }
  }
  clickCatcherCallback() {
    const {
      onResetInpageMode
    } = this.props;
    onResetInpageMode();
  }
  renderEditControllerDOM() {
    return /*#__PURE__*/_jsx("div", {
      "data-test-id": "hs-overlay-component"
    });
  }
  renderLayoutModeClickCatcher() {
    const {
      currentInpageMode
    } = this.props;
    return /*#__PURE__*/_jsx("div", {
      "data-test-id": "hs-click-catcher-component",
      children: currentInpageMode === InpageModes.LAYOUT && /*#__PURE__*/_jsx(ClickCatcher, {
        onClickCallback: () => this.clickCatcherCallback()
      })
    });
  }
  renderToolbarContainer() {
    return /*#__PURE__*/_jsx("div", {
      id: "tinymce-toolbar",
      style: {
        position: 'fixed',
        insetBlockStart: 0,
        insetInlineStart: 0,
        insetInlineEnd: 0,
        zIndex: Z_INDEX_MAX_LAYERS.LEVEL_5
      }
    });
  }
  renderUIComponentRoot() {
    const className = `${NAMESPACE_CLASS} mce-root-node`;
    // @bend-expect trellis-tokenized
    return /*#__PURE__*/_jsx("div", {
      ref: node => {
        this.uiComponentRoot = node;
        if (node) {
          node.style.setProperty('position', 'static', 'important');
        }
      },
      className: className
    });
  }
  mountXrayPageCrawler() {
    return /*#__PURE__*/_jsx(XRayPageCrawlerContainer, {});
  }
  render() {
    if (isPreviewOnly()) {
      return null;
    }
    return /*#__PURE__*/_jsxs("div", {
      children: [this.renderToolbarContainer(), this.renderUIComponentRoot(), this.renderEditControllerDOM(), this.renderLayoutModeClickCatcher(), this.mountXrayPageCrawler(), this.props.children]
    });
  }
}
export default SharedDragDropContext(InpageRoot);